import React from "react";

/**
 * PrimaryButton — thin wrapper for the app's default emerald CTA.
 */
export function PrimaryButton({ children, className = "", disabled, loading, ...rest }) {
  return (
    <button
      disabled={disabled || loading}
      {...rest}
      className={`h-12 rounded-2xl bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold text-sm px-5 shadow-sm hover:shadow transition-all active:scale-[0.98] ${className}`}
    >
      {loading ? "Please wait..." : children}
    </button>
  );
}

export function SecondaryButton({ children, className = "", ...rest }) {
  return (
    <button
      {...rest}
      className={`h-12 rounded-2xl bg-slate-50 hover:bg-slate-100 text-slate-800 font-semibold text-sm px-5 border border-slate-200 transition-all active:scale-[0.98] ${className}`}
    >
      {children}
    </button>
  );
}
